"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 获取文件后缀名
 */
function getFileSuffix(name) {
    var index = name.lastIndexOf('.');
    var suffix = name.substr(index).toLocaleLowerCase();
    return suffix || '';
}
exports.getFileSuffix = getFileSuffix;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0RmlsZVN1ZmZpeC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9nZXRGaWxlU3VmZml4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUE7O0dBRUc7QUFDSCxTQUFnQixhQUFhLENBQUUsSUFBWTtJQUN6QyxJQUFNLEtBQUssR0FBRyxJQUFJLENBQUMsV0FBVyxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQ25DLElBQU0sTUFBTSxHQUFHLElBQUksQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUMsaUJBQWlCLEVBQUUsQ0FBQTtJQUNyRCxPQUFPLE1BQU0sSUFBSSxFQUFFLENBQUE7QUFDckIsQ0FBQztBQUpELHNDQUlDIn0=